import { uniq } from 'shelljs'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    lang: localStorage.getItem('lang')?localStorage.getItem('lang'):0 //0中文 1英文
}

const mutations = {
    setLang(state,data){
      localStorage.setItem('lang',data)
      state.lang=data
    }
}

export default new Vuex.Store({
    state,
    mutations,
    getters: {
        lang: state => state.lang
    },
    
})


// WEBPACK FOOTER //
// ./src/store/index.js